<ng-container *ngFor="let user of userList; let index = index">
  <framework-person-image [person]="user" [size]="size" *ngIf="index < numberToShow" [ngStyle]="{'z-index':index+1}">
  </framework-person-image>
</ng-container>

<div *ngIf="count > 1 " class="counter">+{{count}}</div>
